<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'vehicleIpvaCrud'"
            :crudName="$t('IPVA')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table" :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "vehicleIpvaTable",
      showMessageImport: false,
      vehicleIpvaCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "vehicle_id",
        "ipva_value",
        "payment_date_f",
        "actions",
      ],
      tableData: [],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "vehicle_id", "payment_date_f"],
        sortable: ["id", "vehicle_id", "ipva_value", "payment_date_f"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort",
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          vehicle_id: this.$t('Vehicle'),
          ipva_value: this.$t('IPVA Value'),
          payment_date: this.$t('Payment Date'),
          actions: this.$t('action'),
        },
        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {},
        templates: {
          vehicle_id: function (h, row, index) {
            return row.vehicle ? row.vehicle.name : ""
          },
          ipva_value: function (h, row) {
            return this.$options.filters.money(row.ipva_value);
          }
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["vehicle"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "vehicle_ipvas",
      dataForm: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        vehicle_id: this.$t('Vehicle'),
        ipva_value: this.$t('IPVA Value'),
        payment_date_f: this.$t('Payment Date'),
        actions: this.$t('action'),
      }
      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }
    }
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        vehicle_id: "vehicle[name]",
        ipva_value: "ipva_value",
        payment_date_f: "payment_date",
        status: "status"
      };

      let filters = "";
      $.each(query, function (index, value) {
        if (!value) return;

        if (index === 'payment_date_f' && value.includes('/')) {
          const [day, month, year] = value.split('/');
          value = `${year}-${month}-${day}`;
        }

        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
